<template>
  <div class="info-wrap container trans">
    <sign-header
      :headerConfig="headerConfig"
      @handleClickIocn="handleClickIocn"
    />
    <div class="main">
      <div class="information">
        <div class="info-title">
          <h2 class="tit">报名信息</h2>
          <span
            class="edit"
            @click="editInfo"
            v-show="this.currentSignup.status != '已完成'"
            >修改信息</span
          >
        </div>
        <div class="info-content">
          <div class="items" v-for="item in infoList" :key="item.id">
            {{ item.label }} : {{ item.content }}
          </div>
        </div>
      </div>
      
      <!-- <el-button
        @click.stop="$router.replace('/')"
        class="return-main"
        >返回首页</el-button
      > -->
    </div>
    <PayIndex style="padding: 10px 0 15px; !important"></PayIndex>
  </div>
</template>

<script>
import signHeader from "@/components/header";
import CurrentConferMixin from "@/mixin/CurrentConference";
import CurrentUserMixin from "@/mixin/CurrentUser";
import PayIndex from '@/views/pay';
export default {
  name: "informations",
  components: {
    signHeader,
    PayIndex,
  },
  mixins: [CurrentConferMixin, CurrentUserMixin],
  data() {
    return {
      headerConfig: {
        headerIcon: "city ct-cuowu",
        headerTitle: "报名信息",
      },
      dialogShow: false,
      dialogConfig: {
        title: "抱歉,审核未通过",
        width: "80%",
      },
      currentView: "examineFail",
      editInfoFlag: true,
    };
  },

  computed: {
    infoList() {
      // console.log("D:-------------");
      // console.log(this.currentSignup.attendid);
      // console.log(typeof this.currentSignup.attendid);
      // console.log("F:-------------");
      //  console.log(this.localItem.attendid);
      //  console.log(typeof this.localItem.attendid);
      console.log("info");
      console.log(this.currentSignup);
      let list = [
        { id: 1, label: "姓名", content: this.currentSignup.name },
        { id: 2, label: "手机号", content: this.currentSignup.phone },
        { id: 3, label: "单位名称", content: this.currentSignup.company },
        { id: 4, label: "职务", content: this.currentSignup.job },
        { id: 5, label: "电子邮箱", content: this.currentSignup.email },
        { id: 6, label: "参会身份", content: this.currentSignup.attendid.name },
        { id: 7, label: "报名时间", content: this.$moment(this.currentSignup.create_time).format('YYYY年MM月DD日 HH时mm分ss秒')},
        {
          id: 8,
          label: "报名状态",
          content: this.currentSignup.status,
        },
        {
          id: 9,
          label: "参加会议",
          content: this.currentSignup.conference.title,
        },
        {
          id: 10,
          label: "会场",
          content: this.getConfsites(),
        },
      ];
      if(this.currentSignup.pub_trans_name && this.currentSignup.pub_trans_name.length>0){list.push({ id: 11, label: "对公转账人姓名", content: this.currentSignup.pub_trans_name})}
      if(this.currentSignup.pub_trans_comp && this.currentSignup.pub_trans_comp.length>0){list.push({ id: 12, label: "对公转账人单位", content: this.currentSignup.pub_trans_comp})}
      if(this.currentSignup.pub_trans_phone && this.currentSignup.pub_trans_phone.length>0){list.push({ id: 13, label: "对公转账人电话", content: this.currentSignup.pub_trans_phone})}
      if(this.currentSignup.title_type && this.currentSignup.title_type.length>0){list.push({ id: 14, label: "发票抬头类型", content: this.currentSignup.title_type})}
      if(this.currentSignup.fplx && this.currentSignup.fplx.length>0){list.push({ id: 14, label: "发票类型", content: this.currentSignup.fplx})}
      if(this.currentSignup.ghdwmc && this.currentSignup.ghdwmc.length>0){list.push({ id: 15, label: "发票购买方名称", content: this.currentSignup.ghdwmc})}
      //if(this.currentSignup.ghsjh && this.currentSignup.ghsjh.length>0){list.push({ id: 16, label: "发票购买方手机号", content: this.currentSignup.ghsjh})}
      if(this.currentSignup.ghnsrsbh && this.currentSignup.ghnsrsbh.length>0){list.push({ id: 17, label: "发票购买方税号/身份证号", content: this.currentSignup.ghnsrsbh})}
      if(this.currentSignup.ghdz && this.currentSignup.ghdz.length>0){list.push({ id: 18, label: "发票购买方地址", content: this.currentSignup.ghdz})}
      if(this.currentSignup.ghdh && this.currentSignup.ghdh.length>0){list.push({ id: 18, label: "发票购买方电话", content: this.currentSignup.ghdh})}
      if(this.currentSignup.ghyh && this.currentSignup.ghyh.length>0){list.push({ id: 19, label: "发票购买方银行名称", content: this.currentSignup.ghyh})}
      if(this.currentSignup.ghzh && this.currentSignup.ghzh.length>0){list.push({ id: 19, label: "发票购买方银行账号", content: this.currentSignup.ghzh})}
      return list;
    },
  },
  
  methods: {
    
    handleClickIocn() {
      this.$router.replace('/');
    },
    editInfo(){
      this.$router.push({"name": "editInfo"})
    },

    handleClickSure() {
      this.dialogShow = false;
    },

    getConfsites(){
      let confsites=new Array();
      this.currentSignup.confsites.forEach(element => {
       confsites.push(element.name);
      });
      return confsites.join("，");
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin: 0 15px;

  .information {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .info-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .tit {
      font-size: 16px;
      color: var(--main-color);
      padding-left: 8px;
      font-weight: bold;
      border-left: 4px solid var(--main-color);
    }

    .edit {
      color: var(--main-color);
      font-weight: bold;
    }
  }

  .info-content {
    width: 100%;
    padding: 15px;
    margin-top: 15px;
    background: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    box-sizing: border-box;

    .items {
      font-size: 14px;
      color: #999;
      line-height: 30px;
      margin-top: 15px;
      border-bottom: 1px solid #f2f3f3;

      &:first-child {
        margin-top: 0;
      }

      span {
        color: var(--main-color);
      }
    }
  }

  .wrap {
    width: 100%;
    padding: 15px;
    margin-top: 15px;
    background: #fff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    box-sizing: border-box;
  }
  .return-main {
    width: 100%;
    margin-top: 50px;
    background: var(--main-color);
    color: #fff;
    border: none;
  }

}
::v-deep .el-dialog {
  background: var(--main-color);
  border-radius: 5px;
  .el-dialog__title,
  .el-dialog__close {
    color: #fff;
  }
}
</style>